"use strict";

var _iterator = require("babel-runtime/core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("babel-runtime/core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = require("babel-runtime/core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = _setPrototypeOf2.default || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? (0, _create2.default)(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = _promise2.default))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof _symbol2.default === "function" && (g[_iterator2.default] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classNames = require("classnames");
var next_1 = require("@alicd/next");
var AddressStore_1 = require("./AddressStore");
var Common_1 = require("./Common");
var CNAddressIntlCascader_1 = require("./CNAddressIntlCascader");
function getDataSource(node) {
    if (!node || node.isLeaf || !node.children || !node.children.length) {
        return [];
    }
    return node.children.map(function (i) {
        return { label: Common_1.getLabelIntl(i), value: i.value };
    });
}
function normalizeToId(value) {
    if (Array.isArray(value)) {
        return Common_1.lastOr(value, undefined);
    }
    return value;
}
var CNAddressIntl = /** @class */function (_super) {
    __extends(CNAddressIntl, _super);
    function CNAddressIntl(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: []
        };
        _this.handleUserSelect = _this.handleUserSelect.bind(_this);
        _this.getOverlayContainer = _this.getOverlayContainer.bind(_this);
        return _this;
    }
    CNAddressIntl.prototype.componentDidMount = function () {
        var value = this.props.value || this.props.defaultValue;
        var valueId = normalizeToId(value) || "0";
        this.handleSelect(valueId);
    };
    CNAddressIntl.prototype.componentDidUpdate = function (prevProps, prevState) {
        return __awaiter(this, void 0, void 0, function () {
            var lastValue, thisValue, valueNow;
            return __generator(this, function (_a) {
                lastValue = normalizeToId(prevProps.value);
                thisValue = normalizeToId(this.props.value);
                if (lastValue != thisValue) {
                    if (typeof thisValue == "undefined") {
                        this.handleSelect("0");
                    } else if (typeof thisValue == "string") {
                        this.handleSelect(thisValue);
                    } else if (Array.isArray(thisValue)) {
                        this.setState({ value: thisValue });
                    }
                }
                valueNow = Common_1.selectionToId(this.state.value);
                if (valueNow != Common_1.selectionToId(prevState.value)) {
                    this.handleSelect(valueNow);
                }
                return [2 /*return*/];
            });
        });
    };
    CNAddressIntl.prototype.setStateAsync = function (updater) {
        var _this = this;
        return new _promise2.default(function (resolve, reject) {
            return _this.setState(updater, resolve);
        });
    };
    CNAddressIntl.prototype.getOverlayContainer = function () {
        var container = this.props.container;
        if (this.props.container) {
            if (typeof container == "function") {
                return container();
            }
            return container;
        }
        return this.refs.gatewayWrapper;
    };
    CNAddressIntl.prototype.handleSelect = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var nodePre, node, nodeChain, idChain;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nodePre = this.props.addressStore.impl.getNodeByIdSync(value);
                        if (!(!nodePre || !nodePre.isLeaf && !nodePre.children)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.addressStore.impl.getNodeById(value, true)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        node = this.props.addressStore.impl.getNodeByIdSync(value);
                        nodeChain = Common_1.nodeChainFromNode(node);
                        idChain = nodeChain.map(function (i) {
                            return i.id;
                        }).slice(1);
                        return [4 /*yield*/, this.setStateAsync({ value: idChain })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, nodeChain];
                }
            });
        });
    };
    CNAddressIntl.prototype.handleUserSelect = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var nodeChain, idChain;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nodeChain = Common_1.nodeChainFromNode(this.props.addressStore.impl.getNodeByIdSync(value));
                        idChain = nodeChain.map(function (i) {
                            return i.id;
                        }).slice(1);
                        typeof this.props.onChange == "function" && this.props.onChange(idChain, nodeChain);
                        return [4 /*yield*/, this.handleSelect(value)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CNAddressIntl.prototype.renderSelectBox = function (value, parentID) {
        var SelectComp = next_1.Select;
        var parentNode = this.props.addressStore.impl.getNodeByIdSync(parentID);
        if (!parentNode) {
            throw new Error("no such node " + parentID);
        }
        if (parentNode.isLeaf || !parentNode.children || !parentNode.children.length) {
            return null;
        }
        // TODO: complete logic for level in case of SelectBox mode
        if (this.props.level && Common_1.getNodeLevelInTree(parentNode) >= this.props.level) {
            return null;
        }
        return React.createElement(SelectComp, { key: parentID, className: "next-cn-address-iu-list", value: value, onChange: this.handleUserSelect, size: this.props.size, dataSource: getDataSource(parentNode), showSearch: true, autoWidth: false, placeholder: this.props.placeholder, container: this.getOverlayContainer });
    };
    CNAddressIntl.prototype.renderSelectBoxes = function () {
        var _this = this;
        var box = function box(value, index) {
            return _this.renderSelectBox(value, index ? _this.state.value[index - 1] : "0");
        };
        return [this.state.value.map(box), this.renderSelectBox(undefined, Common_1.selectionToId(this.state.value))];
    };
    CNAddressIntl.prototype.renderCascader = function () {
        return React.createElement("div", { className: "next-cn-address-multi-overlay" }, React.createElement(CNAddressIntlCascader_1.default, { value: this.state.value, onChange: this.handleUserSelect, rootNodeId: "0", addressStore: this.props.addressStore, maxLevel: this.props.level }));
    };
    CNAddressIntl.prototype.renderCascaderBox = function () {
        var SelectComp = next_1.Select;
        var displayValue = this.state.value.map(this.props.addressStore.impl.getNodeByIdSync).map(function (i) {
            return Common_1.getLabelIntl(i);
        }).join(" / ") || undefined;
        return React.createElement(SelectComp, { size: this.props.size, placeholder: this.props.placeholder, overlay: this.renderCascader(), container: this.getOverlayContainer, autoWidth: false, value: displayValue });
    };
    CNAddressIntl.prototype.render = function () {
        return React.createElement("span", { className: classNames("next-cn-address-iu", this.props.size || "medium", this.props.className), style: this.props.style }, this.props.kind == "cascader" ? this.renderCascaderBox() : this.renderSelectBoxes(), React.createElement("span", { ref: "gatewayWrapper" }));
    };
    CNAddressIntl.propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        onChange: PropTypes.func,
        size: PropTypes.oneOf(["small", "medium", "large"]),
        placeholder: PropTypes.string,
        container: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
        kind: PropTypes.oneOf(["cascader", "select"]),
        level: PropTypes.number,
        addressStore: PropTypes.object
    };
    CNAddressIntl.defaultProps = {
        addressStore: AddressStore_1.defaultAddressStoreCNUser
    };
    return CNAddressIntl;
}(React.Component);
exports.default = CNAddressIntl;
//# sourceMappingURL=CNAddressIntl.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/CNAddressIntl.js
// module id = 561
// module chunks = 0